import { render, staticRenderFns } from "./EmergencyDrill.vue?vue&type=template&id=1f854296&"
import script from "./EmergencyDrill.vue?vue&type=script&lang=js&"
export * from "./EmergencyDrill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports